<template>
  <div
    class="pt-5"
    :class="$vuetify.breakpoint.xlOnly ? 'screen-xl' : 'screen-under-xl'"
  >
    <v-row no-gutters>
      <v-col
        cols="12"
        :style="$vuetify.breakpoint.xlOnly ? 'margin-left: -40px' : ''"
      >
        <div class="d-flex">
          <div class="pt-1 pr-2">
            <v-btn icon @click="backToPreviousScreen">
              <v-icon size="34" color="accent"
                >icon-alertadis-angle-left-b</v-icon
              >
            </v-btn>
          </div>
          <div>
            <div class="user-config-title">
              <span>Configurações</span>
            </div>
            <div>
              <span class="user-config-sub-title"
                >Defina suas preferências no AlertaDIS.</span
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="pt-7" no-gutters>
      <v-col cols="12">
        <v-tabs
          v-model="userConfigTab"
          background-color="transparent"
          style="border-bottom: 1px solid #522b0a"
          show-arrows
        >
          <v-tabs-slider color="accent"></v-tabs-slider>
          <v-tab>REGIÕES FAVORITAS</v-tab>
          <v-tab>MEU PERFIL</v-tab>
          <v-tab>ALTERAR SENHA</v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="userConfigTab"
          style="background-color: transparent"
        >
          <v-tab-item>
            <v-row no-gutters>
              <v-col cols="12" v-if="loadingAnimation">
                <lottie
                  class="loading-animation"
                  :options="alertaDisLoadingStationData"
                  :height="370"
                  :width="100"
                />
              </v-col>
              <v-col v-else cols="12">
                <v-row no-gutters>
                  <v-col
                    class="pt-8"
                    cols="12"
                    v-if="$vuetify.breakpoint.mdAndUp"
                  >
                    <div class="my-2 info-alert">
                      <div class="d-flex">
                        <div class="d-flex align-center">
                          <v-icon color="primary"
                            >icon-alertadis-info-circle</v-icon
                          >
                        </div>
                        <div class="pl-2 info-alert-text d-flex align-center">
                          Para cada tipo (regionais, agências e municípios) você
                          pode selecionar no mínimo 1 e no máximo 5 regiões.
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="pt-4" cols="12">
                    <div>
                      <span class="reg-fav-title">Regiões favoritas</span>
                    </div>
                    <div
                      class="d-flex flex-column"
                      v-if="$vuetify.breakpoint.mdAndUp"
                    >
                      <span class="reg-fav-subtitle"
                        >Ao acessar o AlertaDIS serão apresentados os dados das
                        regiões favoritas.
                      </span>
                      <div>
                        <span class="reg-fav-subtitle"
                          >As notificações com
                        </span>
                        <span class="reg-fav-subtitle-bold"
                          >alertas de interrupções
                        </span>
                        <span class="reg-fav-subtitle"
                          >que você receberá no aplicativo ou na versão web
                          também seguirão as opções selecionadas.</span
                        >
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="pt-6" no-gutters>
                  <v-col
                    cols="12"
                    class="pa-3"
                    style="
                      border: 1px solid var(--v-secondary-lighten3);
                      border-radius: 8px;
                    "
                  >
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
                        <v-row no-gutters>
                          <v-col cols="12">
                            <div class="pl-2">
                              <span class="tab-3-title">Regionais</span>
                            </div>
                          </v-col>
                          <v-col class="pt-6" cols="12">
                            <v-btn
                              :block="!$vuetify.breakpoint.lgAndUp"
                              height="48"
                              v-for="(regional, i) in regionalsList"
                              :key="i"
                              :class="
                                isSelectedRegional(regional)
                                  ? 'regional-btn regional-btn-active'
                                  : 'regional-btn'
                              "
                              @click="toggleItemRegional(regional)"
                            >
                              <div>
                                <v-icon class="px-1" color="accent">{{
                                  regional.icon
                                }}</v-icon>
                                <span class="regional-btn-text">{{
                                  regional.fullname
                                }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <div>
                                <v-icon
                                  class="pl-1"
                                  size="16"
                                  :color="
                                    isSelectedRegional(regional)
                                      ? 'favorite'
                                      : 'gray'
                                  "
                                  >icon-alertadis-star</v-icon
                                >
                              </div>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                        :class="
                          $vuetify.breakpoint.lgAndUp
                            ? 'switch-high-screen'
                            : 'switch-low-screen'
                        "
                      >
                        <div class="pl-2" style="margin-top: -20px">
                          <v-switch
                            v-model="notifications.regional"
                            inset
                            color="success"
                            label="Notificações"
                            hide-details
                          ></v-switch>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="pt-6" no-gutters>
                  <v-col
                    cols="12"
                    class="pa-3"
                    style="
                      border: 1px solid var(--v-secondary-lighten3);
                      border-radius: 8px;
                    "
                  >
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
                        <v-row no-gutters>
                          <v-col cols="12">
                            <div class="pl-2">
                              <span class="tab-3-title">Base de Serviço de Campo</span>
                            </div>
                          </v-col>
                          <v-col
                            class="pt-6"
                            :class="
                              $vuetify.breakpoint.lgAndUp
                                ? 'd-flex'
                                : 'd-flex flex-column'
                            "
                            cols="12"
                          >
                            <div class="pr-1" style="height: 48px">
                              <v-autocomplete
                                background-color="secondary"
                                solo
                                append-icon="icon-alertadis-angle-down"
                                prepend-inner-icon="icon-alertadis-plus-circle"
                                color="accent"
                                label="Adicionar base de Serviço de Campo"
                                :items="agenciesList"
                                :item-text="item => `${item.name} - ${item.id}`"
                                item-value="name"
                                multiple
                                return-object
                                hide-details="true"
                                class="custom-auto-complete"
                                :style="
                                  $vuetify.breakpoint.lgAndUp
                                    ? 'width: 340px'
                                    : 'width: 100%'
                                "
                                :search-input.sync="searchAgency"
                              >
                                <template v-slot:selection=""></template>
                                <template #item="{ item }">
                                  <v-list-item
                                    @click="toggleItemAgency(item)"
                                    class="d-flex"
                                    :disabled="selectedAgency.length > 4"
                                  >
                                    <div>
                                      <v-simple-checkbox
                                        v-ripple
                                        color="accent"
                                        :value="isSelectedAgency(item)"
                                        :disabled="selectedAgency.length > 4"
                                        @click="toggleItemAgency(item)"
                                      />
                                    </div>
                                    <div class="ml-2 d-flex align-center">
                                      <span class="sig-reg">{{
                                        item.regional
                                      }}</span>
                                      <span class="sig-reg ml-1"
                                        >{{ item.id }}
                                      </span>
                                      <span class="pl-2">{{ item.name }}</span>
                                    </div>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </div>
                            <div
                              v-for="(agency, index) in selectedAgency"
                              :key="index"
                              class="agency-card"
                            >
                              <div class="d-flex">
                                <div>
                                  <v-btn
                                    icon
                                    @click.stop="removeAgency(agency)"
                                  >
                                    <v-icon size="18" color="accent">
                                      icon-alertadis-times-circle</v-icon
                                    ></v-btn
                                  >
                                </div>
                                <div class="pr-2 d-flex flex-column">
                                  <div class="agency-card-sigla">
                                    {{ agency.id }}
                                  </div>
                                  <div class="agency-card-name">
                                    {{ agency.name }}
                                  </div>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <div>
                                <v-icon class="px-2" size="16" color="favorite"
                                  >icon-alertadis-star</v-icon
                                >
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                        :class="
                          $vuetify.breakpoint.lgAndUp
                            ? 'switch-high-screen'
                            : 'switch-low-screen'
                        "
                      >
                        <div class="pl-2" style="margin-top: -20px">
                          <v-switch
                            v-model="notifications.agencies"
                            inset
                            color="success"
                            label="Notificações"
                            hide-details
                          ></v-switch>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="pt-6" no-gutters>
                  <v-col
                    cols="12"
                    class="pa-3"
                    style="
                      border: 1px solid var(--v-secondary-lighten3);
                      border-radius: 8px;
                    "
                  >
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
                        <v-row no-gutters>
                          <v-col cols="12">
                            <div class="pl-2">
                              <span class="tab-3-title">Municípios</span>
                            </div>
                          </v-col>
                          <v-col
                            class="pt-6"
                            :class="
                              $vuetify.breakpoint.lgAndUp
                                ? 'd-flex'
                                : 'd-flex flex-column'
                            "
                            cols="12"
                          >
                            <div class="pr-1" style="height: 48px">
                              <v-autocomplete
                                background-color="secondary"
                                solo
                                append-icon="icon-alertadis-angle-down"
                                prepend-inner-icon="icon-alertadis-plus-circle"
                                color="accent"
                                label="Adicionar município"
                                :items="countiesList"
                                item-text="name"
                                item-value="cityId"
                                multiple
                                return-object
                                hide-details="true"
                                class="custom-auto-complete"
                                :style="
                                  $vuetify.breakpoint.lgAndUp
                                    ? 'width: 340px'
                                    : 'width: 100%'
                                "
                                :search-input.sync="searchCountie"
                                :filter="filterCountie"
                              >
                                <template v-slot:selection=""></template>
                                <template #item="{ item }">
                                  <v-list-item
                                    @click="toggleItemCounty(item)"
                                    class="d-flex"
                                    :disabled="selectedCounty.length > 4"
                                  >
                                    <div>
                                      <v-simple-checkbox
                                        v-ripple
                                        color="accent"
                                        :value="isSelectedCounty(item)"
                                        :disabled="selectedCounty.lenght > 4"
                                        @click="toggleItemCounty(item)"
                                      />
                                    </div>
                                    <div class="ml-2 d-flex align-center">
                                      <span class="sig-reg">{{
                                        item.regional
                                      }}</span>
                                      <div v-if="item.agencies" class="d-flex">
                                        <span class="sig-reg ml-1"
                                          >{{ item.agencies[0] }}
                                        </span>
                                        <span
                                          v-if="item.agencies.length > 1"
                                          class="sig-reg ml-1"
                                          >{{ item.agencies[1] }}
                                        </span>
                                      </div>
                                      <span class="pl-2">{{ item.name }}</span>
                                    </div>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </div>
                            <div
                              v-for="(county, index) in selectedCounty"
                              :key="index"
                              class="agency-card"
                            >
                              <div class="d-flex align-center">
                                <div>
                                  <v-btn
                                    icon
                                    @click.stop="removeCounty(county)"
                                  >
                                    <v-icon size="18" color="accent">
                                      icon-alertadis-times-circle</v-icon
                                    ></v-btn
                                  >
                                </div>
                                <div class="pr-2 d-flex flex-column">
                                  <div class="agency-card-name">
                                    {{ county.name }}
                                  </div>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <div>
                                <v-icon class="px-2" size="16" color="favorite"
                                  >icon-alertadis-star</v-icon
                                >
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                        :class="
                          $vuetify.breakpoint.lgAndUp
                            ? 'switch-high-screen'
                            : 'switch-low-screen'
                        "
                      >
                        <div class="pl-2" style="margin-top: -20px">
                          <v-switch
                            v-model="notifications.counties"
                            inset
                            color="success"
                            label="Notificações"
                            hide-details
                          ></v-switch>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="pt-10 pb-4">
                    <v-btn
                      class="btn-form"
                      color="accent lighten-1"
                      height="50"
                      large
                      :loading="userConfigsLoadingButton"
                      @click="saveUserConfigs"
                    >
                      <span>Salvar</span>
                    </v-btn>
                    <v-tooltip
                      content-class="arrow tooltip-top redefine-btn-tooltip"
                      top
                      max-width="300"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-form ml-6"
                          color="secondary lighten-3"
                          height="50"
                          large
                          @click="resetSelectLocations"
                        >
                          <span>Redefinir</span>
                        </v-btn>
                      </template>
                      <span
                        >Redefinir seleção de regiões favoritas para o padrão do
                        AlertaDIS</span
                      >
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row no-gutters v-if="loadingAnimation">
              <lottie
                class="loading-animation"
                :options="alertaDisLoadingStationData"
                :height="370"
                :width="100"
              />
            </v-row>
            <v-row v-else no-gutters>
              <v-col cols="12" class="pt-8 pb-2">
                <span class="tab-3-title">Meu perfil</span>
              </v-col>
              <v-col cols="12">
                <v-form ref="formResetProfile" lazy-validation>
                  <div class="pt-2 form-input-group">
                    <v-text-field
                      class="text-field"
                      id="name"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="name"
                      :rules="[(v) => !!v || 'Campo obrigatório.']"
                      outlined
                      required
                      placeholder="Informe seu nome completo"
                    />
                    <label for="name">Nome Completo</label>
                  </div>
                  <div class="pt-2 form-input-group">
                    <v-select
                      class="text-field"
                      id="setor"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="selectedSector"
                      :items="sectors"
                      outlined
                      item-text="name"
                      item-value="id"
                      append-icon="icon-alertadis-angle-down"
                    >
                      <template v-slot:append>
                        <v-icon color="accent"
                          >icon-alertadis-angle-down</v-icon
                        >
                      </template>
                    </v-select>
                    <label for="setor">Setor</label>
                  </div>
                </v-form>
              </v-col>
              <v-col cols="12" class="pt-12">
                <v-btn
                  class="btn-form"
                  color="accent lighten-1"
                  height="50"
                  large
                  :loading="loading"
                  @click="saveUserInfo"
                >
                  <span>Salvar</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row no-gutters>
              <v-col cols="12" class="pt-8 pb-2">
                <span class="tab-3-title">Alterar a senha</span>
              </v-col>
              <v-col cols="12">
                <v-form ref="formResetPassword" lazy-validation>
                  <div class="pt-2 form-input-group">
                    <v-text-field
                      class="text-field"
                      id="oldPassword"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="oldPassword"
                      :rules="[(v) => !!v || 'Campo obrigatório.']"
                      outlined
                      required
                      prepend-inner-icon="icon-alertadis-padlock"
                      :type="showOldPassword ? 'text' : 'password'"
                      placeholder="Informe a senha atual"
                      hide-details
                    />
                    <label for="oldPassword">Senha atual</label>
                  </div>
                  <v-checkbox
                    class="mt-1 check-form"
                    color="accent lighten-1"
                    v-model="showOldPassword"
                    label="Mostrar a senha atual"
                  />
                  <div class="pt-2 form-input-group">
                    <v-text-field
                      class="text-field"
                      id="newPassword"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="newPassword"
                      :rules="[passwordRules]"
                      outlined
                      required
                      prepend-inner-icon="icon-alertadis-padlock"
                      :append-icon="
                        passwordRules === true ? 'icon-alertadis-check' : ''
                      "
                      :type="showNewPassword ? 'text' : 'password'"
                      placeholder="Informe a senha"
                      hide-details
                    />
                    <label for="newPassword">Nova Senha</label>
                  </div>
                  <v-checkbox
                    class="mt-1 check-form"
                    color="accent lighten-1"
                    v-model="showNewPassword"
                    label="Mostrar a nova senha"
                  />

                  <div class="ml-3 my-3">
                    <v-row>
                      <v-icon
                        :color="leastEightCharacters ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules"
                        >Pelo menos 8 caracteres</span
                      >
                    </v-row>
                    <v-row class="mt-5">
                      <v-icon :color="leastOneUpperCase ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules"
                        >Pelo menos 1 letra maiúscula</span
                      >
                    </v-row>
                    <v-row class="mt-5">
                      <v-icon :color="leastOneNumber ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules">Pelo menos 1 número</span>
                    </v-row>
                    <v-row class="mt-5">
                      <v-icon
                        :color="leastOneSpecialChar ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules"
                        >Pelo menos 1 caractere especial</span
                      >
                    </v-row>
                  </div>
                </v-form>
              </v-col>
              <v-col cols="12" class="pt-12">
                <v-btn
                  class="btn-form"
                  color="accent lighten-1"
                  height="50"
                  large
                  :loading="loading"
                  @click="confirmResetPassword"
                >
                  <span>Alterar senha</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { snackbar } from "@/core/controller/snackbar_controller";
import UserService from "@/api/rest-administrative/user.service";
import departmentService from "@/api/rest-administrative/department.service";
import { mapGetters } from "vuex";
import Lottie from "@/core/component/lottie.vue";
import alertaDisLoadingLottie from "@/assets/loadingAlertaDisAnimation.json";

export default {
  components: {
    Lottie,
  },
  data: () => ({
    isProduction: process.env.NODE_ENV === "production",
    alertaDisLoadingStationData: {
      animationData: alertaDisLoadingLottie,
    },
    loadingAnimation: false,
    user: null,
    userConfigTab: 0,
    name: "",
    searchAgency: "",
    searchCountie: "",
    selectedSector: null,
    sectors: [],
    selectedItem: 0,
    oldPassword: "",
    newPassword: "",
    showOldPassword: false,
    showNewPassword: false,
    loading: false,
    passwordRulesValue: false,
    notifications: {
      regional: true,
      agencies: false,
      counties: false,
    },
    selectedRegionals: [
      {
        id: 88,
        name: "DOCCMN",
        fullname: "DOCCMN",
        icon: "",
        fav: true,
      },
      {
        id: 89,
        name: "DOCCSL",
        fullname: "DOCCSL",
        icon: "",
        fav: true,
      },
      {
        id: 90,
        name: "DOCMSL",
        fullname: "DOCMSL",
        icon: "",
        fav: true,
      },
      {
        id: 91,
        name: "DOCNRO",
        fullname: "DOCNRO",
        icon: "",
        fav: true,
      },
      {
        id: 92,
        name: "DOCNRT",
        fullname: "DOCNRT",
        icon: "",
        fav: true,
      },
      {
        id: 93,
        name: "DOCOST",
        fullname: "DOCOST",
        icon: "",
        fav: true,
      },
      {
        id: 94,
        name: "DOCSUD",
        fullname: "DOCSUD",
        icon: "",
        fav: true,
      },
    ],
    selectedAgency: [
      {
        area: 11049.5321123251,
        id: "BSCGVA",
        name: "GUARAPUAVA",
        regional: "DOCCSL",
        regionalId: 89,
        ucQuantity: 55476,
        updated: "2025-08-04T22:21:31+0000",
        fav: true,
      },
      {
        area: 1411.47609207845,
        id: "BSCCTC",
        name: "Curitiba Centro",
        regional: "DOCCMN",
        regionalId: 88,
        ucQuantity: 436027,
        updated: "2025-08-04T22:21:31+0000",
        fav: true,
      },
      {
        area: 3958.96263698762,
        id: "BSCMGA",
        name: "MARINGA",
        regional: "DOCNRO",
        regionalId: 91,
        ucQuantity: 375664,
        updated: "2025-08-04T22:21:31+0000",
        fav: true,
      },
      {
        area: 8522.17466649198,
        id: "BSCCEL",
        name: "CASCAVEL",
        regional: "DOCOST",
        regionalId: 93,
        ucQuantity: 237266,
        updated: "2025-08-04T22:21:31+0000",
        fav: true,
      },
      {
        area: 2583.66635465882,
        id: "BSCLNA",
        name: "LONDRINA",
        regional: "DOCNRT",
        regionalId: 92,
        ucQuantity: 304499,
        updated: "2025-08-04T22:21:31+0000",
        fav: true,
      },
    ],
    selectedCounty: [
      {
        cityId: 4109401,
        name: "Guarapuava",
        state: "PARANA",
        ucQuantity: 55476,
        regionalId: 89,
        regional: "DOCCSL",
        agencies: ["BSCGVA"],
      },
      {
        cityId: 4106902,
        name: "Curitiba",
        state: "PARANA",
        ucQuantity: 436024,
        regionalId: 88,
        regional: "DOCCMN",
        agencies: ["BSCCTS", "BSCCTC"],
      },
      {
        cityId: 4115200,
        name: "Maringá",
        state: "PARANA",
        ucQuantity: 375664,
        regionalId: 91,
        regional: "DOCNRO",
        agencies: ["BSCMGA"],
      },
      {
        cityId: 4104808,
        name: "Cascavel",
        state: "PARANA",
        ucQuantity: 237266,
        regionalId: 93,
        regional: "DOCOST",
        agencies: ["BSCCEL"],
      },
      {
        cityId: 4113700,
        name: "Londrina",
        state: "PARANA",
        ucQuantity: 304499,
        regionalId: 92,
        regional: "DOCNRT",
        agencies: ["BSCLNA"],
      },
    ],
  }),
  async mounted() {
    this.loadingAnimation = true;
    await this.$store.dispatch("fetchUserConfigs");
    this.getUserConfigs();
    this.loadingAnimation = false;
  },
  watch: {
    newPassword(value) {
      this.passwordRules = this.validatePassword(value);
    },
    userConfigTab(value) {
      if (value == 1) {
        this.getCurrentUserData();
      }
    },
  },
  computed: {
    ...mapGetters([
      "regionalsList",
      "agenciesList",
      "countiesList",
      "userConfigs",
      "userConfigsLoadingButton",
    ]),
    passwordRules: {
      set(value) {
        if (value) {
          this.passwordRulesValue = value;
          return;
        }
        this.passwordRulesValue = true;
      },
      get() {
        return this.passwordRulesValue;
      },
    },
    leastEightCharacters() {
      return this.newPassword.length >= 8;
    },
    leastOneUpperCase() {
      return /[A-Z]/.test(this.newPassword);
    },
    leastOneNumber() {
      return /[0-9]/.test(this.newPassword);
    },
    leastOneSpecialChar() {
      return /(?=.*[!@#$%^&*])/.test(this.newPassword);
    },
    isAdmin() {
      let roles = this.$store.getters.currentUser.attributes.roles;
      if (roles == "AlertaDIS_ADMIN") {
        return true;
      }
      return false;
    },
  },
  methods: {
    filterCountie(item, queryText) {
      if (item.name){
        return (
          item.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(queryText.toLowerCase()) ||
          item.name.toLowerCase().includes(queryText.toLowerCase())
        );
      }
    },
    async saveUserInfo() {
      if (this.$refs.formResetProfile.validate()) {
        this.loading = true;
        try {
          const userPayload = { ...this.user };
          userPayload.name = this.name;
          userPayload.departmentId = this.selectedSector;
          await UserService.putUser(userPayload.id, userPayload);
          this.$store.dispatch("updateUserDetails", userPayload);
          snackbar.show({
            type: "success",
            title: "Sucesso",
            message: "Dados alterados com sucesso!",
            timeout: 4000,
          });
        } catch (error) {
          snackbar.show({
            type: "error",
            title: "Erro",
            message: error,
            timeout: 4000,
          });
        } finally {
          this.loading = false;
        }
      }
    },
    async getCurrentUserData() {
      this.loadingAnimation = true;
      try {
        const response = await UserService.getCurrentUserinfo();
        this.user = response.data;
        const departments =
          await departmentService.getDepartmentsByOrganization(
            this.user.organizationId
          );
        this.name = this.user.name;
        this.sectors = departments.data;
        this.selectedSector = this.user.departmentId;
      } catch (error) {
        snackbar.show({
          type: "error",
          title: "Erro",
          message: error,
          timeout: 4000,
        });
      } finally {
        this.loadingAnimation = false;
      }
    },
    validatePassword(value) {
      !value
        ? "Verifique os requisitos abaixo para criar a nova senha."
        : undefined;

      if (!value) {
        return "Verifique os requisitos abaixo para criar a nova senha.";
      }

      if (
        value.length < 8 ||
        !/[A-Z]/.test(value) ||
        !/[0-9]/.test(value) ||
        !/(?=.*[!@#$%^&*])/.test(value)
      ) {
        return "Verifique os requisitos abaixo para criar a nova senha.";
      }
      if (value == "") return true;
    },
    async confirmResetPassword() {
      if (this.$refs.formResetPassword.validate()) {
        this.loading = true;
        try {
          await this.$store.dispatch("updateInternalPassword", {
            newPassword: this.newPassword,
            oldPassword: this.oldPassword,
          });
          snackbar.show({
            type: "success",
            title: "Senha alterada com sucesso",
            timeout: 3000,
          });
        } catch (error) {
          snackbar.show({
            type: "error",
            title: "Erro",
            message: error.response.data.message,
            timeout: 5000,
          });
        } finally {
          this.loading = false;
          this.oldPassword = "";
          this.newPassword = "";
          this.$refs.formResetPassword.resetValidation();
        }
      }
    },
    isSelectedRegional(item) {
      return this.selectedRegionals.some((el) => el.id === item.id);
    },
    toggleItemRegional(item) {
      if (this.selectedRegionals.some((el) => el.id === item.id)) {
        if (this.selectedRegionals.length > 1) {
          this.removeRegional(item);
        }
      } else {
        this.selectedRegionals.push(item);
      }
    },
    removeRegional(item) {
      if (this.selectedRegionals.some((el) => el.id == item.id)) {
        let index = this.selectedRegionals.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.selectedRegionals.splice(index, 1);
        }
      }
    },
    isSelectedAgency(item) {
      return this.selectedAgency.some((el) => el.id === item.id);
    },
    toggleItemAgency(item) {
      this.searchAgency = "";
      if (this.selectedAgency.some((el) => el.id === item.id)) {
        this.removeAgency(item);
      } else {
        this.selectedAgency.push(item);
      }
    },
    removeAgency(item) {
      if (this.selectedAgency.length > 1) {
        if (this.selectedAgency.some((el) => el.id == item.id)) {
          let index = this.selectedAgency.map((e) => e.id).indexOf(item.id);
          if (index > -1) {
            this.selectedAgency.splice(index, 1);
          }
        }
      }
    },
    isSelectedCounty(item) {
      return this.selectedCounty.some((el) => el.cityId === item.cityId);
    },
    toggleItemCounty(item) {
      this.searchCountie = "";
      if (this.selectedCounty.some((el) => el.cityId === item.cityId)) {
        this.removeCounty(item);
      } else {
        this.selectedCounty.push(item);
      }
    },
    removeCounty(item) {
      if (this.selectedCounty.length > 1) {
        if (this.selectedCounty.some((el) => el.cityId == item.cityId)) {
          let index = this.selectedCounty
            .map((e) => e.cityId)
            .indexOf(item.cityId);
          if (index > -1) {
            this.selectedCounty.splice(index, 1);
          }
        }
      }
    },
    backToPreviousScreen() {
      this.$router.go(-1);
    },
    resetSelectLocations() {
      this.selectedRegionals = [
        {
          id: 88,
          name: "DOCCMN",
          fullname: "DOCCMN",
          icon: "",
          fav: true,
        },
        {
          id: 89,
          name: "DOCCSL",
          fullname: "DOCCSL",
          icon: "",
          fav: true,
        },
        {
          id: 90,
          name: "DOCMSL",
          fullname: "DOCMSL",
          icon: "",
          fav: true,
        },
        {
          id: 91,
          name: "DOCNRO",
          fullname: "DOCNRO",
          icon: "",
          fav: true,
        },
        {
          id: 92,
          name: "DOCNRT",
          fullname: "DOCNRT",
          icon: "",
          fav: true,
        },
        {
          id: 93,
          name: "DOCOST",
          fullname: "DOCOST",
          icon: "",
          fav: true,
        },
        {
          id: 94,
          name: "DOCSUD",
          fullname: "DOCSUD",
          icon: "",
          fav: true,
        },
      ];
      this.selectedAgency = [
        {
          area: 11049.5321123251,
          id: "BSCGVA",
          name: "GUARAPUAVA",
          regional: "DOCCSL",
          regionalId: 89,
          ucQuantity: 55476,
          updated: "2025-08-04T22:21:31+0000",
          fav: true,
        },
        {
          area: 1411.47609207845,
          id: "BSCCTC",
          name: "Curitiba Centro",
          regional: "DOCCMN",
          regionalId: 88,
          ucQuantity: 436027,
          updated: "2025-08-04T22:21:31+0000",
          fav: true,
        },
        {
          area: 3958.96263698762,
          id: "BSCMGA",
          name: "MARINGA",
          regional: "DOCNRO",
          regionalId: 91,
          ucQuantity: 375664,
          updated: "2025-08-04T22:21:31+0000",
          fav: true,
        },
        {
          area: 8522.17466649198,
          id: "BSCCEL",
          name: "CASCAVEL",
          regional: "DOCOST",
          regionalId: 93,
          ucQuantity: 237266,
          updated: "2025-08-04T22:21:31+0000",
          fav: true,
        },
        {
          area: 2583.66635465882,
          id: "BSCLNA",
          name: "LONDRINA",
          regional: "DOCNRT",
          regionalId: 92,
          ucQuantity: 304499,
          updated: "2025-08-04T22:21:31+0000",
          fav: true,
        },
      ];
      this.selectedCounty = [
        {
          cityId: 4109401,
          name: "Guarapuava",
          state: "PARANA",
          ucQuantity: 55476,
          regionalId: 89,
          regional: "DOCCSL",
          agencies: ["BSCGVA"],
        },
        {
          cityId: 4106902,
          name: "Curitiba",
          state: "PARANA",
          ucQuantity: 436024,
          regionalId: 88,
          regional: "DOCCMN",
          agencies: ["BSCCTS", "BSCCTC"],
        },
        {
          cityId: 4115200,
          name: "Maringá",
          state: "PARANA",
          ucQuantity: 375664,
          regionalId: 91,
          regional: "DOCNRO",
          agencies: ["BSCMGA"],
        },
        {
          cityId: 4104808,
          name: "Cascavel",
          state: "PARANA",
          ucQuantity: 237266,
          regionalId: 93,
          regional: "DOCOST",
          agencies: ["BSCCEL"],
        },
        {
          cityId: 4113700,
          name: "Londrina",
          state: "PARANA",
          ucQuantity: 304499,
          regionalId: 92,
          regional: "DOCNRT",
          agencies: ["BSCLNA"],
        },
      ];
    },
    getUserConfigs() {
      this.notifications.agencies =
        this.userConfigs.favoriteAgencyNotifications;
      this.notifications.counties = this.userConfigs.favoriteCityNotifications;
      this.notifications.regional =
        this.userConfigs.favoriteRegionalNotifications;
      const arrAgency = [];
      this.userConfigs.favoriteAgencyIds.forEach((e) => {
        this.agenciesList.forEach((el) => {
          if (e == el.id) {
            arrAgency.push(el);
          }
        });
      });
      this.selectedAgency = arrAgency;
      const arrCounty = [];
      this.userConfigs.favoriteCityIds.forEach((e) => {
        this.countiesList.forEach((el) => {
          if (e == el.cityId) {
            arrCounty.push(el);
          }
        });
      });
      this.selectedCounty = arrCounty;
      const arrRegional = [];
      this.userConfigs.favoriteRegionalIds.forEach((e) => {
        this.regionalsList.forEach((el) => {
          if (e == el.id) {
            arrRegional.push(el);
          }
        });
      });
      this.selectedRegionals = arrRegional;
    },
    async saveUserConfigs() {
      const payload = {
        favoriteAgencyIds: [...this.selectedAgency.map((e) => e.id)],
        favoriteAgencyNotifications: this.notifications.agencies,
        favoriteCityIds: [...this.selectedCounty.map((e) => e.cityId)],
        favoriteCityNotifications: this.notifications.counties,
        favoriteRegionalIds: [...this.selectedRegionals.map((e) => e.id)],
        favoriteRegionalNotifications: this.notifications.regional,
      };
      await this.$store.dispatch("changeUserConfigs", payload);
      await this.$store.dispatch("fetchUserConfigs");
      this.fetchUsernotifications();
    },
    async fetchUsernotifications() {
      await this.$store.dispatch("fetchDailyInterruptionRegionalNotifications");
      await this.$store.dispatch("fetchDailyInterruptionAgencyNotifications");
      await this.$store.dispatch("fetchDailyInterruptionCountieNotifications");
    },
  },
};
</script>


<style scoped lang="scss">
.user-config-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}
.user-config-sub-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: var(--v-primary-darken2);
}
label {
  order: -1;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}
.text-field {
  border-radius: 8px;
}
.btn-form {
  text-transform: none;
  border-radius: 8px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

.form-input-group >>> .v-input__icon--append .v-icon {
  color: var(--v-success-base) !important;
}

.tab-3-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}

.screen-xl {
  padding-left: 200px;
  padding-right: 200px;
}
.screen-under-xl {
  padding-left: 20px;
  padding-right: 20px;
}

.info-alert {
  padding: 5px;
  border-radius: 8px;
  color: var(--v-primary-base);
  background-color: var(--v-secondary-base) !important;
}

.info-alert-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.reg-fav-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}

.reg-fav-subtitle {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}
.reg-fav-subtitle-bold {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.regional-btn {
  margin-left: 4px;
  margin-top: 4px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: var(--v-primary-base);
  border: 1px solid var(--v-primary-base);
  border-radius: 8px;
  background-color: var(--v-secondary-base) !important;
  text-transform: none;
  .regional-btn-icon {
    color: #bac2cf;
  }
}

.regional-btn-active {
  background-color: var(--v-secondary-base) !important;
  border: 1px solid var(--v-accent-base);
  .regional-btn-icon {
    color: var(--v-accent-base);
  }
  .regional-btn-text {
    color: var(--v-accent-base);
  }
}

.switch-high-screen {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.switch-low-screen {
  margin-top: 16px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.custom-auto-complete {
  margin-top: 4px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  border-radius: 8px;
  position: relative;
  border: 1px solid var(--v-primary-base);
}

.agency-card {
  display: flex;
  align-items: center;
  margin-right: 4px;
  margin-top: 4px;
  background-color: var(--v-secondary-base);
  height: 50px;
  border-radius: 8px;
  border: 1px solid var(--v-accent-base);
}

.agency-card-sigla {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.4px;
  color: #828d9e;
}

.agency-card-name {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-base);
}

.sig-reg {
  border-radius: 4px;
  padding: 3px;
  margin-right: 2px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
  background-color: rgba(242, 242, 248, 0.1);
}

.redefine-btn-tooltip {
  opacity: 0.9;
  background: var(--v-secondary-base);
}
.tooltip-top::before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: "";
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-top.arrow::before {
  opacity: 0.9;
  border-top: solid 6px var(--v-secondary-base) !important;
}
</style>
